// Brand mark — IPC logo (customer-supplied).
export default function Logo({ className = "h-10 w-10" }) {
  return (
    <div
      className={`grid place-items-center overflow-hidden rounded-full bg-white shadow-sm ring-1 ring-slate-100 ${className}`}
      aria-label="IPC logo"
    >
      <img
        src="/logo.png?v=4"
        alt="Investors Property Consultant"
        className="h-[92%] w-[92%] object-contain"
        draggable={false}
      />
    </div>
  );
}
